import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { LoaderManager } from '@brainfocus/web/router/loader_manager';

// Exported so tests can wrap components with a fixed LoaderManager instance
// (LoaderProvider builds its own; tests need a reference they can drive).
export const LoaderContext = createContext<LoaderManager | null>(null);

export function LoaderProvider({ children }: { children: preact.ComponentChildren }) {
    const loaderManager = new LoaderManager();

    return (
        <LoaderContext.Provider value={loaderManager}>
            {children}
        </LoaderContext.Provider>
    );
}

export function useLoaderManager(): LoaderManager {
    const manager = useContext(LoaderContext);
    if (!manager) {
        throw new Error('useLoaderManager must be used within LoaderProvider');
    }
    return manager;
}
